import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/sections/Hero";
import SocialProof from "@/components/sections/SocialProof";
import ProblemSection from "@/components/sections/ProblemSection";
import HowItWorks from "@/components/sections/HowItWorks";
import VideoSection from "@/components/sections/VideoSection";
import Features from "@/components/sections/Features";
import Services from "@/components/sections/Services";
import AIDemo from "@/components/sections/AIDemo";
import LiveService from "@/components/sections/LiveService";
import LaunchLocation from "@/components/sections/LaunchLocation";
import Leaderboard from "@/components/sections/Leaderboard";
import ProviderSection from "@/components/sections/ProviderSection";
import BetterWay from "@/components/sections/BetterWay";
import FinalCTA from "@/components/sections/FinalCTA";
import FAQ from "@/components/sections/FAQ";
import Footer from "@/components/sections/Footer";
import Marquee from "@/components/sections/Marquee";
import { useSiteConfig } from "@/context/SiteConfigContext";
import { LocationProvider } from "@/context/LocationContext";

const REGISTRY = {
  social: () => <SocialProof />,
  problem: () => <ProblemSection />,
  howItWorks: () => <HowItWorks />,
  video: () => <VideoSection />,
  features: () => <Features />,
  services: () => <Services />,
  aiDemo: () => <AIDemo />,
  liveService: () => <LiveService />,
  marquee: (cfg) => <Marquee items={cfg.lists.marquee} />,
  launch: () => <LaunchLocation />,
  leaderboard: () => <Leaderboard />,
  provider: () => <ProviderSection />,
  betterWay: () => <BetterWay />,
  finalCta: () => <FinalCTA />,
  faq: () => <FAQ />,
};

export default function Landing() {
  const { config } = useSiteConfig();
  return (
    <LocationProvider>
    <div className="bg-white">
      <Toaster position="top-center" richColors />
      <Navbar />
      <main>
        <Hero />
        {config.sections.filter((s) => s.visible).map((s) => (
          <div key={s.id}>{REGISTRY[s.id]?.(config)}</div>
        ))}
      </main>
      <Footer />
    </div>
    </LocationProvider>
  );
}
